import React, { useState, useEffect } from "react";
import axios from "axios";
import { Route, Routes, useLocation } from "react-router-dom";
import {
  AppShell,
  Burger,
  Group,
  Text,
  Title,
  Box,
  ThemeIcon,
  UnstyledButton,
  useMantineTheme,
  Flex,
} from "@mantine/core";
import { Toaster } from "react-hot-toast";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";

import logo from "@assets/images/logo.png";
import entityColor from "@util/entityColor";
import entityIcon from "@util/entityIcon";
import { Nameplate, SuspenseWrapper, LanguagePicker } from "@components/shared";
import { UserSetSession } from "@components/User";

import { Dashboard, UserDetail } from "@pages/Admin";
import { Nav } from "@components/shared";
import { RealtimeProvider } from "@lib/realtime";
import {
  ChatAwareAppShell,
  ChatProvider,
  ChatTray,
  ChatWidget,
} from "@components/Chat";

import classes from "./UserContainer.module.css";
import { shallow } from "zustand/shallow";
import appStore from "@duck/app-store";

import { UserIndex, EvaluationIndex, EvaluationDetail } from "@pages/Admin";

function UserContainer() {
  const avatarUrl = null;
  const [opened, setOpened] = useState(false);
  const { t } = useTranslation();
  const theme = useMantineTheme();

  const { user } = appStore(
    (state) => ({
      user: state.user,
    }),
    shallow
  );

  const navLinks = [
    {
      text: t("dashboard"),
      to: "",
      icon: entityIcon.dashboard(),
      // color: entityColor.campaign,
    },
    {
      text: t("employee_plural"),
      to: "users",
      icon: entityIcon.user(),
      color: entityColor.user,
    },
    {
      text: t("engagement_singular"),
      to: "engagement",
      icon: entityIcon.engagement(),
      color: entityColor.engagement,
    },
  ];

  return (
    <div>
      <RealtimeProvider enabled>
        <ChatProvider>
        <ChatAwareAppShell
          opened={opened}
          padding="md"
          header={{ height: 65 }}
        >
          <AppShell.Header
            height={65}
            pl="xs"
            pr="xs"
            style={{
              background: "var(--mantine-color-gray-1)",
            }}
          >
            <Group justify="flex-end" align="center" style={{ height: "100%" }}>
              <Flex align="center" gap="md" style={{ flexGrow: 1 }}>
                <div className={classes.burger}>
                  <Burger
                    opened={opened}
                    onClick={() => setOpened(!opened)}
                    size="lg"
                    color={theme.colors.dark[1]}
                  />
                </div>
                <div className={classes.logo}>
                  <img
                    src={logo}
                    alt="clearscreen"
                    style={{
                      width: "80px",
                      height: "50px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </Flex>
              <div className={classes.right}>
                <Group position="right" align="flexEnd">
                  <ChatWidget />
                  <LanguagePicker />
                  <Nameplate title={user.full_name} avatarUrl={avatarUrl} />
                </Group>
              </div>
            </Group>
          </AppShell.Header>
          <AppShell.Navbar hidden={!opened} width={{ sm: 250 }}>
            <div>
              <Nav
                links={navLinks.map((m) => ({
                  ...m,
                  to: `/${m.to}`,
                }))}
              />
              <UnstyledButton
                component={"a"}
                href={"/submit-trouble-ticket"}
                target="_blank"
                style={{
                  display: "block",
                  width: "100%",
                  padding: "var(--mantine-spacing-xs)",
                  backgroundColor: "transparent",
                  borderRadius: "var(--mantine-radius-sm)",
                  // "&:hover": {
                  //   backgroundColor:
                  //     theme.colorScheme === "dark"
                  //       ? theme.colors.dark[6]
                  //       : theme.colors.gray[0],
                  // },
                }}
              >
                <Group>
                  <ThemeIcon variant="light" color={entityColor.ticket}>
                    {entityIcon.ticket()}
                  </ThemeIcon>
                  <Text size="sml">Open support ticket</Text>
                </Group>
              </UnstyledButton>
            </div>
            {/* <Box p="sm" mt="lg">
            <UserSetSession />
          </Box> */}
          </AppShell.Navbar>
          <AppShell.Main
            style={(theme) => ({
              background: theme.colors.gray[0],
            })}
          >
            <ErrorBoundary
              fallback={
                <div>
                  <Title>That's not good!</Title>
                  <Text>Something went wrong and we're going to fix it.</Text>
                </div>
              }
            >
              <SuspenseWrapper>
                <Routes>
                  <Route index element={<Dashboard />} />
                  <Route path="/profile" element={<UserDetail isProfile />} />
                  <Route path="/users" element={<UserIndex />} />
                  <Route path="/users/:id/*" element={<UserDetail />} />
                </Routes>
              </SuspenseWrapper>
            </ErrorBoundary>
          </AppShell.Main>
        </ChatAwareAppShell>
        <ChatTray />
        <Toaster />
        </ChatProvider>
      </RealtimeProvider>
    </div>
  );
}

export default UserContainer;
